import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './GroupScreen.css';
import Nav from '../../components/Nav/Nav'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../features/currentUser'
import { Oval, MagnifyingGlass } from 'react-loader-spinner'
import { getGroupById, getPostWithId, getUserInfoWithId } from '../../services/f';
import { BsPlusCircle, BsInfoCircle, BsFillCheckCircleFill, BsFillHeartFill } from 'react-icons/bs'  //https://react-icons.github.io/react-icons
import { FaComment, FaShare } from 'react-icons/fa'
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';
import { PiUserCircleLight } from 'react-icons/pi'
import Footer from '../../components/Footer';
import { auth } from '../../firebase';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { Helmet } from 'react-helmet';
import { TwitterShareButton } from 'react-twitter-embed';
//see which one google indees and which notif there are dofferences
//check faq groupitem app profile
function GroupScreen() {
  // http://localhost:3000/groupitem?id=sdffsdf
  // http://localhost:3000/group?id=MFbwMsG0SkVnOYTUMZRKeshqBmA2
  const [searchParams, setSearchParams] = useSearchParams();
  let currentUser = useSelector(getCurrentUser).currentUser?.currentUser// ALSO WENNS n user gibt dann wird anderes screen angezeigt
  const navigate = useNavigate()

  const [groupitem, setgroupitem] = useState(null);
  const [copiedlink, setcopiedlink] = useState(false);

  let titledescription
  let titletext

  useEffect(() => {
    let groupid = searchParams.get("id")
    if (groupid === null || groupid === undefined || groupid === "") {
      setgroupitem("groupnotexists")
    } else {
      getGroupById(groupid).then((res) => {
        //console.log("getPostWithId result", res)
        setgroupitem(res)
        titledescription = "Group description:  " + res[1]?.description + "Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute."
        titletext = "Premsi - Group: " + res[1]?.grouptitle
        if (res === "groupnotexists") {
          return
        }
      })
    }

  }, []);

  return (
    <div className='postscreen'>
      <Helmet>
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Premsi | Group - Easily sell your digital content❤️" />
        <meta property="og:description" content="Premsi | Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
        <meta property="og:url" content="https://premsi.com/group" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
        <meta property="og:site_name" content="Premsi - sell digital content" />
        <link rel="canonical" href="https://premsi.com/group" />

        <title>{titletext}</title>
        <meta name="description" content={String(titledescription)} />

        <meta name="twitter:title" content="Premsi" />
        <meta name="twitter:description" content={`New Premsi.com Group`} />
        <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Nav />
      {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}
      <div className="body">
        <div className='grouppostscreen__body'>

          {groupitem === null ?
            <div>
              <Oval
                height={40}
                width={40}
                color="#009FFD"
                wrapperStyle={{ marginTop: 20, flex: "display", alignItems: "center", justifyContent: "center" }}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="white"
                strokeWidth={5}
                strokeWidthSecondary={5}
              />
              <p style={{ marginBottom: 3, textAlign: "center" }}>Loading group...</p>
              <p style={{ textAlign: "center", fontSize: 12 }}>If this takes too long please refresh this window.</p>
            </div>
            :
            (
              groupitem === "groupnotexists"
                ?
                <div>
                  <MagnifyingGlass
                    height={40}
                    width={40}
                    color="#009FFD"
                    wrapperStyle={{ marginTop: 20, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
                    wrapperClass=""
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="white"
                    strokeWidth={5}
                    strokeWidthSecondary={5}
                  />
                  <h1 style={{ marginBottom: 3, textAlign: "center", color: "black", fontSize: 16 }}>No Group...</h1>
                  <h2 style={{ textAlign: "center", fontSize: 12, marginTop: 20 }}>It seems that you have a wrong link and this group doesn't exist</h2>
                  <p style={{ textAlign: "center", fontSize: 12 }}>Please recheck your link.</p>
                  <div style={{ display: "flex", alignItems: "center", marginTop: 20, justifyContent: "center", width: "100%", marginBottom: 5 }}>
                    <button onClick={() => navigate("/alternativehomepage")} style={{ fontSize: 14, fontWeight: "bold", paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderRadius: 10, backgroundColor: "#009FFD", color: "white", borderWidth: 0 }}>Explore others</button>
                  </div>
                </div>
                :
                <>
                  <div class="header">
                    <div class="profile-info">
                      <div >
                        <div class="profile-title">Premsi Group:</div>
                        <div onClick={() => navigate("/user?id=" + groupitem[1]?.creator)} class="group-name">{groupitem[1]?.grouptitle}</div>
                      </div>
                    </div>
                    <div class="stats">
                      <div class="stat">
                        <div class="stat-labelgroup">Members</div>
                        <div class="stat-value">{(groupitem[1]?.membersCount)}</div>
                      </div>
                      <div class="stat">
                        <div class="stat-labelgroup">Messages</div>
                        <div class="stat-value">{(groupitem[1]?.messagesCount)}</div>
                      </div>
                      <div class="stat">
                        <div class="stat-labelgroup">Price</div>
                        <div class="stat-value">{groupitem[1].price}${groupitem[1].onetimefee ? null : "/m"}</div>
                      </div>
                    </div>
                  </div>

                  <div className='groupdescription'>
                    <p class="description-text">
                      {groupitem[1]?.description}
                    </p>
                  </div>

                  <div className='grouppostdiv'>
                    <img
                      loading="lazy"
                      key={groupitem[0]}
                      src={groupitem[1]?.media}
                      style={{ pointerEvents: "none", height: "100%", cursor: "pointer", borderRadius: 30, objectFit: "contain" }}
                      onError={(i) => (i.target.src = require('../../images/pblue-min.webp'))}
                      onClick={() => null}
                      alt={groupitem[1]?.description}
                    />
                  </div>

                  <div class="cta-section">
                    <p class="cta-text">
                      To join this group please <a href="app" class="download-link">download</a> our App.
                    </p>
                  </div>

                  <div class="actions">
                    <button class="action-btn share-btn" onClick={() => (navigator.clipboard.writeText("www.premsi.com/group?id=" + groupitem[0]))}>
                      <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
                      </svg>
                      Share Group
                    </button>
                    <button class="action-btn post-btn">
                      <TwitterShareButton
                        onLoad={function noRefCheck() { }}
                        options={{
                          buttonHashtag: undefined,
                          screenName: undefined,
                          size: 'large',
                          text: "See this new Premsi Group 🔥🧿",
                          //via: 'saurabhnemade'
                        }}
                        placeholder={<div style={{ backgroundColor: 'transparent', color: 'white', margin: 10, padding: 10, textAlign: "center", fontSize: 11 }}>loading x</div>}
                        url={`https://www.premsi.com/group?id=${groupitem[0]}`}
                      />
                    </button>
                  </div>

                  {/* <div className='postinfo'>
                  <div className='postinnerinfo'>

                    <button className='sharebtn' onClick={() => (navigator.clipboard.writeText("www.premsi.com/group?id=" + groupitem[0]), setcopiedlink(true))}>
                      {
                        copiedlink
                          ?
                          <p>Copied ✅</p>
                          :
                          <>
                            <FaShare size={22} color='white' alt='share post' />
                            <p>Share Group</p>
                          </>
                      }
                    </button>
                    <TwitterShareButton
                      onLoad={function noRefCheck() { }}
                      options={{
                        buttonHashtag: undefined,
                        screenName: undefined,
                        size: 'large',
                        text: "See this new Premsi Group 🔥🧿",
                        //via: 'saurabhnemade'
                      }}
                      placeholder={<div style={{ backgroundColor: 'transparent', color: 'white', margin: 10, padding: 10, textAlign: "center", fontSize: 11 }}>loading x</div>}
                      url={`https://www.premsi.com/group?id=${groupitem[0]}`}
                    />
                  </div>
                </div>*/}
                </>
            )
          }
        </div>
      </div>
      <Footer />

    </div>
  )
}

export default GroupScreen


